import React, { useEffect, useState } from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Avatar,
  Divider,
  Spinner,
} from '@chakra-ui/react';
import { fetchProjectComments } from '../../../../ProjectBoardServices/BoardModalAPI/LeftModalAPI/ProjectCommentsTab';

const ProjectCommentsTab = ({ task }) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchComments = async () => {
    const projectCode = task?.relatedProjectCode;
    if (!projectCode) {
      setError('Project code not found.');
      setLoading(false);
      return;
    }

    try {
      // ✅ Service function use kar rahe hain
      const response = await fetchProjectComments(projectCode, 20, 1);
      const rawComments = response.data?.comments || [];

      const parsedComments = rawComments.map((item) => ({
        id: item._id,
        user: {
          name: item.commentedBy?.name || 'Unknown User',
          avatar: '', // Add avatar if available
        },
        message: item.message || '',
        time: item.datetime || '',
      }));

      setComments(parsedComments);
      setError('');
    } catch (err) {
      console.error('Failed to fetch project comments:', err);
      if (err.response) {
        setError(
          `API Error ${err.response.status}: ${err.response.data?.message || 'Something went wrong'}`
        );
      } else if (err.request) {
        setError('No response received from the server.');
      } else {
        setError('Request setup error: ' + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchComments();
    // eslint-disable-next-line
  }, [task?.relatedProjectCode]);

  if (loading) {
    return (
      <Box py={6} textAlign="center">
        <Spinner />
      </Box>
    );
  }

  if (error) {
    return (
      <Text fontSize="14px" color="red.500" textAlign="center" py={6}>
        {error}
      </Text>
    );
  }

  if (comments.length === 0) {
    return (
      <Text fontSize="14px" color="gray.500" textAlign="center" py={6}>
        No comments available for this project.
      </Text>
    );
  }

  return (
    <VStack spacing={4} align="stretch" maxH="400px" overflowY="auto" pr={2}>
      {comments.map(({ id, user, message, time }) => (
        <Box key={id} p={3} borderRadius="md" bg="gray.50" boxShadow="sm">
          <HStack align="start" spacing={3}>
            <Avatar size="sm" name={user.name} src={user.avatar} />
            <Box flex="1">
              <Text fontWeight="semibold" fontSize="14px" color="gray.700">
                {user.name}
              </Text>
              <Box
                fontSize="14px"
                color="gray.600"
                mt={1}
                dangerouslySetInnerHTML={{ __html: message }}
              />
              <Text fontSize="12px" color="gray.500" mt={2}>
                {time}
              </Text>
            </Box>
          </HStack>
          <Divider mt={3} />
        </Box>
      ))}
    </VStack>
  );
};

export default ProjectCommentsTab;
